import { useMutation } from '@tanstack/react-query'
import { setAppSpinning } from 'app/appSlice'
import { useAppDispatch } from 'hooks/useRedux'
import { useEffect, useState } from 'react'

export default function useExportById(mutateApi, fileName, fileType) {
  const dispatch = useAppDispatch()

  const [file, setFile] = useState(null)
  const mutation = useMutation({
    mutationKey: 'exportById',
    mutationFn: mutateApi,
    onMutate: () => dispatch(setAppSpinning(true)),
    onSettled: () => dispatch(setAppSpinning(false)),
    onSuccess: (res) => {
      const fileUrl = `${process.env.REACT_APP_BASE_URL}${res.metadata?.fileURL}`
      if (fileUrl) {
        fetch(fileUrl)
          .then((r) => r.blob())
          .then((blob) => {
            const newFile = new File([blob], fileName, {
              type: fileType,
            })
            setFile(newFile)
          })
          .catch((err) => {
            console.error('Tải file thất bại:', err)
          })
      } else {
        const newFile = new File([res], fileName, {
          type: fileType,
        })
        setFile(newFile)
      }
    },
  })

  useEffect(() => {
    if (file) {
      const url = URL.createObjectURL(file)
      open(url, '_blank')
    }
    return () => {
      URL.revokeObjectURL(file)
      setFile(null)
    }
  }, [file])
  return {
    file,
    exportFunc: mutation.mutate,
    exportFuncAsync: mutation.mutateAsync,
  }
}
